// @flow
import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { AnswerFieldsets } from './SearchForm';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

const label = 'Answers';
const AnswerSearch = (props: *) => {
  const clientProps = useContext(ClientContext);

  if (clientProps && getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const newPathname = location.pathname.replace(
      /\/answers(?=\/|$)/,
      '/answers-search'
    );
    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  return (
    <SearchView
      label={label}
      primaryFieldsets={AnswerFieldsets.primaryFieldsets}
      extraFieldsets={AnswerFieldsets.extraFieldsets}
      {...props}
    />
  );
};

AnswerSearch.label = label;

export default AnswerSearch;



// WEBPACK FOOTER //
// ./src/containers/search/Answers.js